import {colors} from './colors.ts';

const typography = {
  fontFamily: 'var(--font-sf)',
  allVariants: {
    color: colors.primary.base,
    fontFamily: ['SF Pro Text', 'Arial', 'sans-serif'].join(',')
  },
  h1: {
    fontSize: 38,
    lineHeight: '46px',
    fontWeight: 600
  },
  h2: {
    fontSize: 30,
    lineHeight: '38px',
    fontWeight: 600
  },
  h3: {
    fontSize: 24,
    lineHeight: '32px',
    fontWeight: 600
  },
  h4: {
    fontSize: 20,
    lineHeight: '28px',
    fontWeight: 600
  },
  h5: {
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 600
  },
  body2: {
    // base
    fontSize: 14,
    lineHeight: '22px',
    fontWeight: 400
  },
  body1: {
    // sm
    fontSize: 12,
    lineHeight: '20px',
    fontWeight: 400
  },
  subtitle2: {
    // lg
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 400
  },
  subtitle1: {
    // xl
    fontSize: 20,
    lineHeight: '28px',
    fontWeight: 400
  }
};

export default typography;
